import { internal, template } from '../../vendor/elix.js';
import TpChoiceChip from './tp-choice-chip.js';

class TpSportChoiceChip extends TpChoiceChip {

  get sportId() {
    return this[internal.state].sportId;
  }

  set sportId(sportId) {
    this[internal.setState]({ sportId });
  }

  get sportName() {
    return this[internal.state].sportName;
  }

  set sportName(sportName = '') {
    sportName = sportName.toLowerCase().replace(/[^a-z]/g,'');
    this[internal.setState]({ sportName });
  }

  [internal.componentDidMount]() {
    this.appendIcon();
    super[internal.componentDidMount]();
  }

  [internal.render](changed) {
    super[internal.render](changed);
    this.renderIconState();
  }

  appendIcon() {
    const icon = document.createElement('tp-sport-icon');
    icon.setAttribute('slot', 'leading');
    this.appendChild(icon);
  }

  renderIconState() {

    const icon = this.querySelector('tp-sport-icon');

    if (!icon) {
      return;
    }

    icon.colored = !this.selected;

    if (this.sportName) {
      icon.sportName = this.sportName;
    } else {
      icon.sportId = this.sportId;
    }

  }

  get [internal.template]() {

    return template.concat(
      super[internal.template],
      template.html`
        <style>
          slot[name=leading]::slotted(*) {
            color: white;
            font-size: 24px;
          }
        </style>
      `
    );
  }

}

export default TpSportChoiceChip;


